import * as types from "./types";

export const clearState = (chunks = []) => {
  return {
    type: types.CLEAR_STATE,
    payload: chunks,
  };
};

export const rehydrateState = state => {
  return {
    type: types.REHYDRATE_STATE,
    payload: state,
  };
};

export const persistState = state => {
  return {
    type: types.PERSIST_STATE,
    payload: state,
  };
};
